import {useCallback} from 'react';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

import './Nift.sass';

type SuccessRoktProps = {
  url: string;
  onClose: () => void;
};

export const Nift = ({onClose}: SuccessRoktProps) => {
  const onClaimNiftGift = useCallback(() => {
    onClose();
    window.open('https://www.gonift.com/nift_cards/EMQTEST34/start', '_blank');
  }, [onClose]);

  return (
    <Step header={<Header title="Your RSVP is confirmed" onClose={onClose} />}>
      <div className="nift-step-content">
        <img
          src="https://g0.evitecdn.com/invitation/nift.png"
          alt="nift-image"
          className="nift-step-content__image"
          data-qa-id="nift-image"
        />

        <div className="nift-step-content__text-wrapper">
          <Typography variant="paragraph2" semibold>
            Submitting this RSVP just earned you a $30 gift!
          </Typography>

          <Typography variant="paragraph3">
            Thanks for using Evite. Enjoy a $30 gift card on us. Use it to try something new — wine,
            music, food delivery and more.
          </Typography>
        </div>

        <Button
          variant="primary"
          data-qa-id="claim-nift-offer"
          className="nift-step-content__cta"
          onClick={onClaimNiftGift}
          data-impression-tracking="true"
          size="large"
        >
          Claim offer
        </Button>
      </div>
    </Step>
  );
};
